import { unregister } from 'register-service-worker';

unregister();

// Delete SW Cache
if ('caches' in window) {
    caches.keys().then((keyList) => Promise.all(
        keyList.map((key) => caches.delete(key)),
    ));
}
